import { collection, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { store } from '../../config/firebase';
import { useAuth } from '../../contexts/authContext';
import GameByStatusCards from '../ui/gameStatusCards/gameByStatusCards';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import BSCircularProgress from '../ui/progress/circularProgress';
import { hasAccess, Roles } from '../../helpers/access';
import { liveGameDocs } from '../../helpers/games';
import ScoringTable from '../ui/table/scoringTable';

const UserScoring = () => {
  const { currentUser, currentUserProfile } = useAuth();
  const [loading, setLoading] = useState();
  const [games, setGames] = useState([]);

  const [filterRounds, setFilterRound] = useState('');
  const [filterSection, setFilterSection] = useState('');
  const [filteredGames, setFilteredGames] = useState(games);
  const [filterGreens, setFilterGreen] = useState('');

  // const [sections, setSections] = useState([]);
  const [rounds, setRounds] = useState([]);
  // const [greens, setGreens] = useState([]);

  useEffect(() => {
    setLoading(true);
    const collectionRef = collection(store, 'games');
    const q = query(collectionRef, where('scorer.id', '==', currentUser.uid));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const gamesData = liveGameDocs(querySnapshot).map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data()
      }));

      setGames(gamesData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  useEffect(() => {
    let _fgames = games;

    // if (filterSection !== '') {
    //   _fgames = _fgames.filter((g) => g.section === filterSection);
    // }

    if (filterRounds !== '') {
      _fgames = _fgames.filter((g) => g.round === filterRounds);
    }

    // if (filterGreens !== '') {
    //   _fgames = _fgames.filter((g) => g.green === filterGreens);
    // }

    setFilteredGames(_fgames);
  }, [filterRounds, games]);

  useEffect(() => {
    // setSections([...new Set(games.map((g) => g.section))]);
    const rounds = [...new Set(games.map((g) => g.round))];
    console.log('Rounds:', rounds);
    setRounds(rounds);
    // setGreens([...new Set(games.map((g) => g.green))]);
  }, [games]);

  const clearFilters = () => {
    // setFilterSection('');
    setFilterRound('');
    // setFilterGreen('');
  };

  return (
    <Box my={2}>
      <Box display={'flex'} alignItems={'center'} gap={2} flexWrap={'wrap'}>
        <Typography>All Games</Typography>
        {/* <FormControl sx={{ width: 200, my: 2 }}>
          <InputLabel id={'filterSectionsLabel'}>Filter Sections</InputLabel>
          <Select
            labelId="filterSectionsLabel"
            value={filterSection}
            onChange={(event) => setFilterSection(event.target.value)}>
            <MenuItem value={''}>None</MenuItem>
            {sections &&
              sections.map((sec) => (
                <MenuItem key={sec.id} value={sec.id}>
                  {sec.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl> */}
        <FormControl sx={{ width: 200 }}>
          <InputLabel id={'filterRoundsLabel'}>Filter Rounds</InputLabel>
          <Select
            labelId="filterRoundsLabel"
            value={filterRounds}
            onChange={(event) => setFilterRound(event.target.value)}>
            <MenuItem value={''}>None</MenuItem>
            {rounds.map((round) => (
              <MenuItem key={round} value={round}>
                Round {round}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <FormControl sx={{ width: 200, my: 2 }}>
          <InputLabel id={'filterGreenLabel'}>Filter Green</InputLabel>
          <Select
            labelId={'filterGreenLabel'}
            value={filterGreens}
            onChange={(event) => setFilterGreen(event.target.value)}>
            <MenuItem value={''}>None</MenuItem>
            {greens?.map((green, index) => (
              <MenuItem key={green.name} value={green.name}>
                {green.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <Button size="small" variant="text" color="primary" onClick={clearFilters}>
          Clear
        </Button>
      </Box>

      <Box display={'flex'} flexDirection={'row'} p={1} flexWrap={'wrap'} gap={2}>
        {loading ? (
          <BSCircularProgress caption={'Loading Games'} />
        ) : (
          // filteredGames.map((game) => (
          //   <GameByStatusCards
          //     key={game.id}
          //     game={game}
          //     actions={hasAccess(currentUserProfile, Roles.ADMIN)}
          //   />
          // ))
          <ScoringTable games={filteredGames} />
        )}
      </Box>
    </Box>
  );
};

export default UserScoring;
